/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import {
  siteId, fileFetchHasErrored, openedFolder, openedFile, sourceRevision, targetRevision,
  xmlSourceFetchIsLoading, xmlSourceFetchHasErrored, xmlSourceFile,
  xmlTargetFetchIsLoading, xmlTargetFetchHasErrored, xmlTargetFile,
} from '../actions/actionCreator';

import Header from './Header';
import AccountFinder from './AccountFinder';
import FolderView from './FolderView';
import RevisionHistory from './RevisionHistory';
import TabView from './TabView';
import NotFound from './NotFound';

import logo from '../assets/images/logo.png';
import largeLogo from '../assets/images/logo-lrg.png';
import { fetcher } from '../assets/js/fetcher';
import { dvsRestPoint, parserMap, urlPath } from '../assets/js/mapper';

import '../assets/sass/App.scss';

let mapStateToProps = (state) => ({
  invalidSiteId: state.fileFetchHasErrored,
  siteIdCurrent: state.siteId,
  openedFolderCurrent: state.openedFolder,
  openedFileCurrent: state.openedFile,
  sourceRevisionCurrent: state.sourceRevision,
  targetRevisionCurrent: state.targetRevision,
  showingFolders: state.isFileStructureShowing,
  revisionsCurrent: state.revision,
});

let mapDispatchToProps = (dispatch) => ({
  siteId: (account) => dispatch(siteId(account)),
  openedFolder: (folder) => dispatch(openedFolder(folder)),
  openedFile: (file) => dispatch(openedFile(file)),
  sourceRevision: (rev) => dispatch(sourceRevision(rev)),
  targetRevision: (rev) => dispatch(targetRevision(rev)),
  xmlSourceFetchIsLoading: (isLoading) => dispatch(xmlSourceFetchIsLoading(isLoading)),
  xmlSourceFetchHasErrored: (hasErrored) => dispatch(xmlSourceFetchHasErrored(hasErrored)),
  xmlSourceFile: (files) => dispatch(xmlSourceFile(files)),
  xmlTargetFetchIsLoading: (isLoading) => dispatch(xmlTargetFetchIsLoading(isLoading)),
  xmlTargetFetchHasErrored: (hasErrored) => dispatch(xmlTargetFetchHasErrored(hasErrored)),
  xmlTargetFile: (files) => dispatch(xmlTargetFile(files)),
  fileFetchHasErrored: (hasErrored) => dispatch(fileFetchHasErrored(hasErrored)),
});

class AppClass extends React.Component {
  callDVS = (loading, error, success, key, siteId, folder = null, file = null, rev = null, page = 0) => {
    const url = dvsRestPoint(key, siteId, folder, file, rev, page);
    const parser = parserMap[key];
    if (parseInt(rev, 10) !== 0) fetcher(loading, error, success, url, parser);
  };

  scrollToActiveRev = (rev) => {
    const activeRevision = document.querySelectorAll('.well.w' + rev.toString())[0];
    const revisions = document.getElementById('fileRevision');
    let y;
    if (activeRevision) y = activeRevision.offsetTop;
    try { revisions.scrollTop = y - 102; } catch (err) {}
  };

  routeHandler = (key, siteId, folder = null, file = null, sourceRev = null, targetRev = null) => {
    urlPath(key, this.props.navigate, siteId, folder, file, sourceRev, targetRev);
  };

  componentDidMount() {
    const { params } = this.props;
    if (params.siteId) this.props.siteId(params.siteId);
    if (params.folder) this.props.openedFolder(params.folder);
    if (params.file) this.props.openedFile(params.file);
    if (this.props.hasErrored) this.props.fileFetchHasErrored(params.hasErrored);
    if (params.diffSource && params.diffTarget) {
      this.props.sourceRevision(parseInt(params.diffSource, 10));
      this.props.targetRevision(parseInt(params.diffTarget, 10));
      this.callDVS(this.props.xmlSourceFetchIsLoading, this.props.xmlSourceFetchHasErrored, this.props.xmlSourceFile,
        'XML', params.siteId, params.folder, params.file, params.diffSource);
      this.callDVS(this.props.xmlTargetFetchIsLoading, this.props.xmlTargetFetchHasErrored, this.props.xmlTargetFile,
        'XML', params.siteId, params.folder, params.file, params.diffTarget);
    }
  }

  render() {
    const { params } = this.props;
    if (this.props.invalidSiteId) {
      return (
        <Container fluid>
          <Row className="header-row">
            <Header image={logo} />
            <AccountFinder callDVS={this.callDVS} routeHandler={this.routeHandler} accountQueryString={params.siteId} />
          </Row>
          <NotFound />
        </Container>
      );
    }
    return (
      <Container fluid>
        <Row className="header-row">
          <Header image={logo} site={this.props.siteIdCurrent} />
          <AccountFinder callDVS={this.callDVS} routeHandler={this.routeHandler} accountQueryString={params.siteId} />
        </Row>
        <Row className="flex">
          {this.props.siteIdCurrent === '' && (
            <img className="large-logo" src={largeLogo} alt="" />
          )}
          {this.props.showingFolders ? (
            <Col className="account-sidebar column">
              <FolderView callDVS={this.callDVS} routeHandler={this.routeHandler} accountQueryString={params.siteId} folderQueryString={params.folder} fileQueryString={params.file} />
            </Col>
          ) : null}
          <Col className="column file-revision" id="fileRevision">
            <RevisionHistory callDVS={this.callDVS} routeHandler={this.routeHandler} revisionQueryString={params.revision} />
          </Col>
          <Col className="column xml-view-tabs">
            <TabView callDVS={this.callDVS} scrollToActiveRev={this.scrollToActiveRev} routeHandler={this.routeHandler} />
          </Col>
        </Row>
      </Container>
    );
  }
}

const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(AppClass);

export default function App(props) {
  const params = useParams();
  const navigate = useNavigate();
  return <ConnectedApp {...props} params={params} navigate={navigate} />;
}
